import Component from '../../../assets/scripts/modules/component'

export default class CookieNoticeComponent extends Component {
  constructor (element) {
    super(element)
    this.acceptButton = element.querySelector('[data-cookie-notice-accept]')
    this.declineButton = element.querySelector('[data-cookie-notice-decline]')
    this.configureButton = element.querySelector('[data-cookie-notice-configure]')
  }

  init () {
    this.bindEvents()
  }

  bindEvents () {
    if (this.acceptButton) {
      this.acceptButton.addEventListener('click', this.handleAccept.bind(this))
    }
    if (this.declineButton) {
      this.declineButton.addEventListener('click', this.handleDecline.bind(this))
    }
    if (this.configureButton) {
      this.configureButton.addEventListener('click', this.handleConfigure.bind(this))
    }
  }

  handleAccept (event) {
    event.preventDefault()
    this.hide()
  }

  handleDecline (event) {
    event.preventDefault()
    this.hide()
  }

  handleConfigure (event) {
    event.preventDefault()
    if (window.Cookiebot) {
      window.Cookiebot.show()
    }
  }

  show () {
    this.element.hidden = false
  }

  hide () {
    this.element.hidden = true
  }
}
